import { render, staticRenderFns } from "./LmInbox.vue?vue&type=template&id=0d8275ce&scoped=true"
import script from "./LmInbox.vue?vue&type=script&lang=js"
export * from "./LmInbox.vue?vue&type=script&lang=js"
import style0 from "./LmInbox.vue?vue&type=style&index=0&id=0d8275ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8275ce",
  null
  
)

export default component.exports